// extracted by mini-css-extract-plugin
var _1 = "DestinationCard_destItem__b6e9e";
var _2 = "DestinationCard_innerText__b314a";
var _3 = "DestinationCard_label__bc7bc";
var _4 = "DestinationCard_mask__35879";
var _5 = "DestinationCard_placeholder__ba0a9";
export { _1 as "destItem", _2 as "innerText", _3 as "label", _4 as "mask", _5 as "placeholder" }
